// Class: starling.text.BitmapDataEx

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function openfl_display_BitmapData() {return $import(require("openfl/display/BitmapData"));}

// Constructor

var BitmapDataEx = function(width,height,transparent,fillColor) {
	if(fillColor == null) {
		fillColor = 0;
	}
	if(transparent == null) {
		transparent = true;
	}
	this._scale = 1.0;
	(openfl_display_BitmapData().default).call(this,width,height,transparent,fillColor);
}

// Meta

BitmapDataEx.__name__ = "starling.text.BitmapDataEx";
BitmapDataEx.__isInterface__ = false;
BitmapDataEx.__super__ = (openfl_display_BitmapData().default);
BitmapDataEx.prototype = $extend((openfl_display_BitmapData().default).prototype, {
	get_scale: function() {
		return this._scale;
	},
	set_scale: function(value) {
		return this._scale = value;
	}
});
BitmapDataEx.prototype.__class__ = BitmapDataEx.prototype.constructor = $hxClasses["starling.text.BitmapDataEx"] = BitmapDataEx;

// Init



// Statics




// Export

exports.default = BitmapDataEx;